
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import { useHonor } from "../hooks/useHonor";

// ⭐ Usamos tu Header global
import Header from "./components/Header";

const Honor = () => {
  const { honorData } = useHonor();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [idleague, setIdleague] = useState(1);

  // ⭐ OBTENER idleague DESDE LA URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("idleague");
    setIdleague(id ? parseInt(id) : 1);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white p-4">

      {/* ⭐ HEADER CON idleague REAL */}
      <Header
        logo={logo}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        idleague={idleague}
      />

      {/* INTRO / LORE */}
      <div className="my-8 px-4 py-6 bg-gray-900 rounded-lg shadow-lg">
        <h3 className="text-xl font-bold text-yellow-400 mb-2 text-center">
          Sellos de Pureza
        </h3>

        <p className="text-gray-200 text-center">
          En el sombrío milenio 41, donde no hay paz ni esperanza, cada victoria es una chispa de significado en la oscuridad infinita...
          <br /><br />
          Aquí no se premia la suerte, sino la constancia, la lealtad, la ferocidad y la devoción.
          <br /><br />
          Estos logros no son simples medallas. Son ecos de gloria, testimonios de fe, y advertencias para los débiles.
        </p>
      </div>

      {/* LISTA DE HONORES */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {honorData.map((item, index) => (
          <div key={index} className="flex bg-gray-800 rounded-lg shadow-lg overflow-hidden">

            {/* Imagen */}
            <div className="w-1/3">
              <img
                src={`/${item.picture.replace('../', '')}`}
                alt={item.name}
                className="object-cover w-full h-full"
              />
            </div>

            {/* Texto */}
            <div className="w-2/3 p-4">
              <h2 className="text-xl font-semibold mb-2">{item.name}</h2>
              <p className="text-gray-300 mb-2">{item.description}</p>
              <p className="text-gray-400 text-sm italic">{item.lore}</p>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default Honor;
